import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: black;
  padding-top: 32px;
`;



// WEBPACK FOOTER //
// ./src/routes/Events/components/common/Root/Root.js